import React, { useEffect, useState } from 'react';
import './CinemaIntro.css';

const BEATS = ['3', '2', '1'];

export default function CinemaIntro({ onFinish }) {
  const [beat, setBeat] = useState(0);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      const timer = window.setTimeout(onFinish, 250);
      return () => window.clearTimeout(timer);
    }

    const beats = [
      window.setTimeout(() => setBeat(1), 760),
      window.setTimeout(() => setBeat(2), 1520),
      window.setTimeout(() => setBeat(3), 2280),
      window.setTimeout(onFinish, 3400),
    ];
    return () => beats.forEach(window.clearTimeout);
  }, [onFinish]);

  return (
    <div className={`cinema-intro cinema-intro--beat-${beat}`} role="status" aria-label="Открываем сеанс">
      <video
        className={`cinema-intro-video ${videoReady ? 'cinema-intro-video--ready' : ''}`}
        src="/cinema-intro.mp4"
        autoPlay
        muted
        playsInline
        preload="auto"
        onCanPlay={() => setVideoReady(true)}
        aria-hidden="true"
      />
      <div className="cinema-intro-vignette" />
      <div className="cinema-intro-beam" />
      <div className="cinema-intro-letterbox cinema-intro-letterbox--top" />
      <div className="cinema-intro-letterbox cinema-intro-letterbox--bottom" />
      <div className="cinema-intro-content">
        <div className="cinema-intro-topline">WATCHPARTY <span>•</span> ПРИЯТНОГО ПРОСМОТРА</div>
        <div className="cinema-intro-counter" aria-hidden="true">
          <div className="cinema-intro-ring cinema-intro-ring--outer" />
          <div className="cinema-intro-ring cinema-intro-ring--inner" />
          <div className="cinema-intro-cross cinema-intro-cross--horizontal" />
          <div className="cinema-intro-cross cinema-intro-cross--vertical" />
          {BEATS.map((number, index) => (
            <span key={number} className={`cinema-intro-number ${beat === index ? 'cinema-intro-number--active' : ''}`}>{number}</span>
          ))}
        </div>
        <div className="cinema-intro-mark">▶ WATCHPARTY</div>
        <div className="cinema-intro-bottomline">СЕАНС НАЧИНАЕТСЯ</div>
      </div>
      <button className="cinema-intro-skip" type="button" onClick={onFinish}>Пропустить <span>→</span></button>
    </div>
  );
}
